import React from "react";

export default function TokenItem(props) {
  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }
  return (
    <tr onClick={props.onClick} className="tokenTrxrow">
      <td>{props.date}</td>
      <td>{capitalizeFirstLetter(props.transaction_type)}</td>

      <td>
        <p>{props.description}</p>
      </td>
      <td>{props.amount}</td>
    </tr>
  );
}
